import React from 'react';
import './whatSnagEasy.css';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { whatSnagEasyData } from '../../data/whatSnagEasyData';

const WhatSnagEasy = () => {
  const { header, features } = whatSnagEasyData;

  return (
    <div className="what-snageasy-section" id="wgpt3">
      <div className="what-snageasy-container">
        {/* Hero Section */}
        <div className="what-snageasy-hero">
          <div className="hero-badge">
            <CheckCircleIcon className="badge-icon" />
            <span>{header.badge.text}</span>
          </div>
          <h2 className="hero-title">
            {header.title}
          </h2>
          <p className="hero-description">
            {header.description}
          </p>
        </div>

        {/* Features Grid */}
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-card-header">
                <div className="feature-icon-container" style={{ backgroundColor: feature.color + '20' }}>
                  <div className="feature-icon-wrapper" style={{ color: feature.color }}>
                    {feature.icon}
                  </div>
                </div>
                <div className="feature-title-container">
                  <div className="feature-title-bar" style={{ backgroundColor: feature.color }}></div>
                  <h3 className="feature-title">{feature.title}</h3>
                </div>
              </div>
              <div className="feature-content">
                <p className="feature-description">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhatSnagEasy;